import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const ImagesWrapper = styled.div`
  display: flex;
  gap: 16px;
  max-width: 1440px;
  margin: 0 auto;
  overflow: auto;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    height: 514px;
    padding: 32px 16px;
  }

  .swiper {
    width: 100%;
    height: 100%;
    padding: 16px;
  }

  .swiper-slide img {
    display: block;
    height: 100%;
    min-width: 100%;
  }

  .swiper-slide {
    height: 234px;
    width: 303px;

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      width: calc(25% - 8px);
      height: 100%;
    }
  }

  .swiper-slide:nth-child(2n) {
    height: 234px;
    width: 303px;

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      width: calc(25% - 8px);
      height: 100%;
    }
  }

  .swiper-slide:nth-child(3n) {
    height: 234px;

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      width: calc(50% - 16px);
      height: 100%;
    }
  }

  .gatsby-image-wrapper img {
    height: 100%;
  }
`;

const FlexWrapper = styled.div`
  display: flex;
  width: 50%;
  gap: 16px;
`;

const Image = styled(GatsbyImage)`
  height: 100%;
`;

const S = {
  ImagesWrapper,
  FlexWrapper,
  Image,
};

export default S;
